export default __webpack_public_path__ + "img/bg_membership_new-266e3f868fdfb42112f2dca866dbfa0d.png";